$( document ).ready(function() {
    var date = new Date(),
        $pun = $('#Rbpunewsletter'),
        $newsForm = $('#Rbpunewsletter form'),
        minutes = $('#Rbpunewsletter').data('time');
  if ($pun.length === 1){
    date.setTime(date.getTime() + (minutes * 60 * 1000));
    var setCookies = function (){
      $.cookie('cookiesNewsletter', 'disabled', { expires: date, path: '/' } );
    };
    if ($.cookie('cookiesNewsletter') !== "disabled") {
      $(window).on('load',function(){
        $pun.modal('show');
      });
      $pun.on('hidden.bs.modal', setCookies);
      $newsForm.submit(setCookies);     
    }
  }
});